import { Flex, Text } from '@mantine/core'
import React, { useMemo } from 'react'

import { type CoreBookingService } from '@flecto/types'

import { useServiceKind } from '../../hooks/useServiceKind'

export type CellNameProps = {
  bookingService?: CoreBookingService
}

export function CellName({ bookingService }: CellNameProps) {
  const kinds = useServiceKind()
  const serviceKind = useMemo(
    () => kinds.find((kind) => kind.value === bookingService?.service_kind),
    [bookingService]
  )

  return (
    <Flex align='center' gap='sm'>
      <Text fw={500} truncate>
        {serviceKind?.label}
      </Text>
    </Flex>
  )
}
